import React, { StrictMode } from 'react'
import { Outlet } from 'react-router'
import { RequireAuth } from '@core/Components/RequireAuth'
import { useAutoFollowMeAccountCreation } from './hooks/useAutoFollowMeAccountCreation'

export const FollowMeRoot: React.FC = () => {
  useAutoFollowMeAccountCreation()

  return (
    <RequireAuth>
      <StrictMode>
        <Outlet />
      </StrictMode>
    </RequireAuth>
  )
}
